import repository from "../Repository";

export default {
  /**
   * 参照API
   * @param {*} screenId 画面ID
   * @param {*} payload ペイロード
   */
  async list(screenId, payload) {
    return await repository.post(`facility_search_vul_list`, payload, {
      headers: {
        s: screenId
      }
    });
  }
};